'use client';

import { ErrorBoundary } from 'react-error-boundary';
import { PageEmpty } from '@/components/PageEmpty/PageEmpty';
import { CloudAlertIcon } from 'lucide-react';
import Link from 'next/link';

export const ErrorFallback = ({ error, resetErrorBoundary }) => {
  console.error(error);

  return (
    <PageEmpty>
      <CloudAlertIcon color={'#f44336'} size={96} strokeWidth={1.5} />
      <h2 style={{
        fontSize: 24,
        fontWeight: 500,
        marginTop: 24,
        color: '#414141',
      }}>
        Возникла ошибка
      </h2>
      <p style={{
        fontSize: 15,
        fontWeight: 400,
        marginTop: 16,
        marginBottom: 48,
        color: '#41414195',
        padding: '0 24px',
        textAlign: 'center',
      }}>
        Мы уже занимаемся устранением ошибки, повторите попытку позже.
        <br />
        Приносим извинения за неудобства.
      </p>
      <button
        onClick={resetErrorBoundary}
        style={{
          backgroundColor: '#41414125',
          border: 'none',
          padding: '12px 16px',
          borderRadius: 24,
          cursor: 'pointer',
          color: '#414141',
          fontSize: 15,
          fontWeight: 500,
        }}
      >
        Перезагрузить страницу
      </button>
      <div style={{
        marginTop: 16,
      }}>
        или перейти на
        <Link
          style={{
            margin: '0 4px',
            textDecoration: 'none',
            borderBottom: '1px solid #25625A50',
            display: 'inline-block',
            lineHeight: 1.2,
            cursor: 'pointer',
            color: '#414141',
          }}
          href={'/'}
        >
          Главную
        </Link>
      </div>
    </PageEmpty>
  );
};

function ErrorBoundaryFallback({ children }) {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      {children}
    </ErrorBoundary>
  );
}

export default ErrorBoundaryFallback;
